var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 33,
    viewBox: "0 0 36 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6942 2.19842C17.7784 2.04685 17.8939 2 18 2C18.1061 2 18.2216 2.04685 18.3058 2.19842L33.936 30.3196C34.025 30.4798 34.0175 30.6549 33.936 30.8016C33.8559 30.9457 33.7446 31 33.6302 31H2.36983C2.25545 31 2.14409 30.9457 2.06401 30.8016C1.98249 30.6549 1.97501 30.4798 2.06402 30.3196L17.6942 2.19842Z",
    stroke: "currentColor",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1099 22.411H16.8808L16.565 13.5H19.4257L19.1099 22.411ZM17.9954 23.8064C18.4474 23.8064 18.8096 23.933 19.082 24.1861C19.3607 24.4393 19.5 24.7631 19.5 25.1576C19.5 25.5462 19.3607 25.8671 19.082 26.1202C18.8096 26.3734 18.4474 26.5 17.9954 26.5C17.5495 26.5 17.1873 26.3734 16.9087 26.1202C16.6362 25.8671 16.5 25.5462 16.5 25.1576C16.5 24.769 16.6362 24.4481 16.9087 24.195C17.1873 23.9359 17.5495 23.8064 17.9954 23.8064Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.7909357e007acd2018301206843aeb2b.svg";
export { ForwardRef as ReactComponent };